<template>
  <main>
    <!-- page title area start  -->
    <section
      class="page-title-area"
      :style="{
        'background-image':
          'url(' + DynamicImage(serviceObject.backgroundImage) + ')',
      }"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="page-title-content text-center">
              <div class="page-title-heading">
                <h1>{{ serviceObject.title }}</h1>
              </div>
              <nav class="grb-breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link :to="{ name: 'Home' }">Accueil</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link :to="{ name: 'Services' }"
                      >Services</router-link
                    >
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    {{ serviceObject.title }}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- page title area end -->
    <!-- service details area start  -->
    <section class="service-details-area pt-150 pb-80">
      <div class="container">
        <div class="service-details-img wow fadeInUp">
          <div class="row">
            <div class="col-lg-9">
              <div class="service-details-single-img">
                <img
                  :src="DynamicImage(serviceObject.imageOne)"
                  alt="Adex Intégration services"
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div class="row">
                <div class="col-lg-12 col-sm-6">
                  <div class="service-details-single-img">
                    <img
                      :src="DynamicImage(serviceObject.imageTwo)"
                      alt="Adex Intégration services"
                    />
                  </div>
                </div>
                <div class="col-lg-12 col-sm-6">
                  <div class="service-details-single-img">
                    <img
                      :src="DynamicImage(serviceObject.imageThree)"
                      alt="Adex Intégration services"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="service-details-content wow fadeInUp">
          <div class="service-details-heading">
            <h2>{{ serviceObject.title }}</h2>
          </div>
          <p>
            {{ serviceObject.description }}
          </p>
          <div class="row">
            <div
              class="col-md-12 col-lg-4 col-sm-12"
              v-for="serviceItem in serviceObject.listServices"
              :key="serviceItem.title"
            >
              <h5 class="mb-15">{{ serviceItem.title }}</h5>
              <ul class="execute-list">
                <li v-for="item in serviceItem.items" :key="item">
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
          <h4 class="mt-45 mb-25">Explorer plus de services</h4>
          <ServicesSection></ServicesSection>
        </div>
      </div>
    </section>
    <!-- service details area end -->
  </main>
</template>
<script>
import ServicesSection from "@/components/ServicesSection.vue";
export default {
  name: "DataCenterService",
  components: { ServicesSection },
  data() {
    return {
      serviceObject: {
        backgroundImage: "bg/data-center-bg.jpg",
        title: "Data Center",
        imageOne: "service/service-datacenter.jpg",
        imageTwo: "service/service-datacenter-2.jpg",
        imageThree: "service/service-datacenter-3.jpg",
        description:
          "Nous proposons des solutions intégrées qui modernisent votre infrastructure physique tout en optimisant les performances, l'espace et la disponibilité. ADEX Intégration vous propose des solutions d'infrastructure physique pour les datacenters, y compris les composants, les services et les systèmes logiciels pour les architectures informatiques traditionnelles, convergées, hyper-convergées ou personnalisées.",
        listServices: [
          {
            title: "Network & Télécom",
            items: [
              "Réseaux LAN",
              "Réseaux WAN",
              "Sdwan",
              "Connectivité",
              "Scada",
              "Radio",
            ],
          },
          {
            title: "Infrastructure Solution 360",
            items: [
              "Serveurs",
              "Storage",
              "Solution Converged",
              "HyperConverged",
              "Classic",
            ],
          },
          {
            title: "Backup & Recovery Management",
            items: ["Solution de Backup", "Archivage", "PRA"],
          },
          {
            title: "Monitoring & Management",
            items: ["Solution de Monitoring", "Gestion des ressources"],
          },
          {
            title: "Sourcing Hardware",
            items: ["Fourniture d’équipements Hardware"],
          },
        ],
      },
    };
  },
  methods: {
    DynamicImage(img) {
      return require(`../../assets/img/${img}`);
    },
  },
  mounted() {
    document.title = "ADEX Intégration - Data Center";
  },
};
</script>